// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"667":"4d3144cf","773":"763f853e"}[chunkId] + ".chunk.css";
};